// src/components/ErrorView.js
import React from 'react';
import { handleSmartBack, handleTellMeMore } from '../../../shared/utils/navigationUtils';

/**
 * ErrorView
 * 
 * Props:
 * - title (string): main heading, e.g. "Connection Lost"
 * - message (string): short explanation for the error
 * - onRetry (function): callback for "Try Again" button
 * - onGoBack (function): callback for "Go Back" button
 * - isFirstTimeUser (boolean): if true, shows "Tell me more" button and hides retry
 */
export default function ErrorView({
  title = 'Connection Lost',
  message = "We're unable to reach the device's backend system at the moment.",
  onRetry,
  onGoBack,
  isFirstTimeUser = false
}) {
  // Smart go back handler for first-time users
  const handleSmartGoBack = () => {
    if (isFirstTimeUser) {
      handleSmartBack();
    } else {
      // Use the provided onGoBack callback
      onGoBack?.();
    }
  };

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{ minHeight: '100vh', padding: '1rem' }}
    >
      {/* A simple card or container with a max-width */}
      <div className="card p-4 shadow-sm" style={{ maxWidth: '400px', width: '100%' }}>
        <div className="card-body">

          {/* Top icon container */}
          <div className="text-center mb-3">
            <div
              className="rounded-circle d-inline-flex justify-content-center align-items-center"
              style={{
                width: '60px',
                height: '60px',
                backgroundColor: '#eef2ff'
              }}
            >
              {/* You can replace "bi-exclamation" with any relevant icon */}
              <i className="bi bi-exclamation text-primary" style={{ fontSize: '1.5rem' }}></i>
            </div>
          </div>

          {/* Title */}
          <h4 className="mb-2">{title}</h4>
          {/* Subtitle/message */}
          <p className="text-muted mb-4" style={{ lineHeight: 1.4 }}>
            {message}
          </p>

          {/* Buttons */}
          <div className="d-grid gap-2">
            {isFirstTimeUser ? (
              // First-time user buttons
              <>
                <button
                  className="btn btn-primary d-flex align-items-center justify-content-center"
                  onClick={handleTellMeMore}
                >
                  <i className="bi bi-box-arrow-up-right me-2"></i>
                  Tell me more
                </button>

                <button
                  className="btn btn-secondary d-flex align-items-center justify-content-center"
                  onClick={handleSmartGoBack}
                >
                  <i className="bi bi-arrow-left me-2"></i>
                  Go Back
                </button>
              </>
            ) : (
              // Regular error buttons
              <>
                {onRetry && (
                  <button
                    className="btn btn-primary d-flex align-items-center justify-content-center"
                    onClick={onRetry}
                  >
                    <i className="bi bi-arrow-clockwise me-2"></i>
                    Try Again
                  </button>
                )}

                {onGoBack && (
                  <button
                    className="btn btn-secondary d-flex align-items-center justify-content-center"
                    onClick={onGoBack}
                  >
                    <i className="bi bi-arrow-left me-2"></i>
                    Go Back
                  </button>
                )}
              </>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}